export default __webpack_public_path__ + "static/media/Pic16.59caa411.jpg";